/* projects/portal/src/app/pages/employees/employees.component.css */
.filter-field {
  width: 170px;
}
.link {
  color: #8a5a12;
  cursor: pointer;
  text-decoration: none;
  border-bottom: 1px dotted #d8b483;
}
.link:hover {
  border-bottom-style: solid;
}
/*# sourceMappingURL=employees.component.css.map */
